<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >我的数字员工</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item title="虚拟机" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    style="width: 100px"
                                    v-model="data.selectMac"
                                    :options="toolbar.macOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    :options="toolbar.allStatus"
                                    placeholder="全部"
                                    clearable
                                    style="width: 120px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="部署平台" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.realPlatform"
                                    placeholder="全部"
                                    :options="formInput.planPlatform"
                                    clearable
                                    style="width: 100px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入数字员工编号、数字员工名称、业务人员"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button @click="exportDataEvent"
                                    >导出</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        ref="xTable1"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="删除" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeRowEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="修改"
                            width="50"
                            :visible="isShowEditRow"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-pencil-square"
                                    @click="editAdminEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="编辑" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editRowEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="AI助理配置" width="100">
                            <template #default="{ row }">
                                <vxe-button
                                    v-if="row.realPlatform == 'PT003'"
                                    type="text"
                                    icon="fa fa-gear"
                                    width="50"
                                    @click="setupAIAssistant(row)"
                                    :style="{
                                        color:
                                            row.hasAIAssistant > 0
                                                ? 'blue'
                                                : '',
                                    }"
                                ></vxe-button>
                                <vxe-button
                                    v-if="row.realPlatform == 'PT003'"
                                    type="text"
                                    width="50"
                                    icon="fa fa-download"
                                    @click="downloadYaml(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            align="center"
                            title="状态"
                            width="160"
                            resizable
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-bind:class="{
                                        active: row.AuditStatus === '已审核',
                                        error: row.AuditStatus.includes('驳回'),
                                    }"
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.AuditStatus }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="PubState"
                            :visible="false"
                            title="发布阶段"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="empNo"
                            title="数字员工编号"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="数字员工名称"
                            width="220"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="empTypeName"
                            title="数字员工类型"
                            width="120"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="introduction"
                            title="数字员工简介"
                            width="130"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessID"
                            title="开发编号"
                            width="100"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="realPlatformName"
                            title="部署平台"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="deployType"
                            title="运行方式"
                            width="100"
                            sortable
                        ></vxe-column>

                        <vxe-column
                            field="UserName"
                            title="业务人员"
                            width="100"
                            show-overflow
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="techName"
                            title="辅导老师"
                            width="100"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="sceneName"
                            title="场景组担当"
                            width="140"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="上岗申请时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="AuditTime"
                            title="上岗审批时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="MachineName"
                            title="虚拟机"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ManSingleTime"
                            title="Before-人工每次耗时(分钟)"
                            width="200"
                        ></vxe-column>
                        <vxe-column
                            field="ManFrequency"
                            title="Before-人工每月次数"
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="RobotSingleTime"
                            title="After-每次耗时(分钟)"
                            width="200"
                            sorable
                        ></vxe-column>
                        <vxe-column
                            field="RobotMonthRun"
                            title="After-每月次数"
                            width="140"
                        ></vxe-column>
                        <vxe-column
                            field="DevelopTime"
                            title="开发时间(小时)"
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="SingleSaveTime"
                            title="单次节省-时间(分钟)"
                            show-overflow
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="CreateMan"
                            title="申请人"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="CreateManEmail"
                            title="申请人邮箱"
                            width="180"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="UserID"
                            title="UserID"
                            show-overflow
                            width="100"
                            :visible="false"
                            sortable
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        :page-sizes="[
                            10,
                            20,
                            100,
                            200,
                            { label: '全部数据', value: 10000 },
                        ]"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>

            <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
                <template #default>
                    <div>
                        <vxe-form :data="userTablePager">
                            <vxe-form-item
                                title="关键字"
                                field="searchKey"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.searchKey"
                                        placeholder="请输入姓名或邮箱"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findUserData"
                                        @keyup.enter="findUserData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        status="primary"
                                        @click="confirmSelectUser"
                                        >确定</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="24">
                                <template #title>
                                    <span>已选(</span
                                    ><span style="color: red">双击选择</span
                                    ><span>)</span>
                                </template>
                                <template #default>
                                    <div v-if="formInput.userSelType == 1">
                                        <template
                                            v-for="(item, index) in formInput
                                                .formData.DevelopIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                        </template>
                                    </div>
                                    <div v-else-if="formInput.userSelType == 2">
                                        <template
                                            v-for="(item, index) in formInput
                                                .formData.UserIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                            <va-icon
                                                class="icon-left input-icon"
                                                @click="clearUser(item.ID)"
                                                name="clear"
                                            />
                                        </template>
                                    </div>
                                    <div v-else-if="formInput.userSelType == 3">
                                        <template
                                            v-for="(
                                                item, index
                                            ) in formInputRetire.formData
                                                .leaderIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                        </template>
                                    </div>
                                    <div v-if="formInput.userSelType == 4">
                                        <template
                                            v-for="(
                                                item, index
                                            ) in formInputAddMan.formData
                                                .UserIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                            <va-icon
                                                class="icon-left input-icon"
                                                @click="
                                                    clearUserAddMan(item.ID)
                                                "
                                                name="clear"
                                            />
                                        </template>
                                    </div>
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="dtUser"
                            ref="xTableUser"
                            height="300"
                            @cell-dblclick="chooseUser"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Uid"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="UserName"
                                title="姓名"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobZb"
                                title="总部"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobName"
                                title="部门"
                                width="120"
                                show-overflow
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="UserMail"
                                title="邮箱"
                                width="200"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="Id"
                                title="Id"
                                width="10"
                                :visible="false"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="userTablePager.currentPage"
                            v-model:page-size="userTablePager.pageSize"
                            :total="userTablePager.totalResult"
                            @page-change="userListPageChange"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
    <addAIAssistant
        ref="addAIAssistantRef"
        :key="addComponentKey"
        @flashIndex="getComponentsListApi"
    >
    </addAIAssistant>
    <addNewPublish
        ref="addNewPublishRef"
        @flashPubList="findData"
    ></addNewPublish>
</template>

<script>
import Qs from "qs";
import { reactive, ref } from "vue";
import { VXETable } from "vxe-table";
import XEUtils from "xe-utils";
import MyAuditLine from "../myPlug/MyAuditLine";
import addAIAssistant from "./AddAIAssistant.vue";
import addNewPublish from "../dashboardNew/addNewPublish.vue";

export default {
    name: "DEmpProfile",
    components: { MyAuditLine, addAIAssistant, addNewPublish },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });

        const toolbar = reactive({
            loading: false,
            macOptions: [],
            allStatus: [],
            allReqPlatform: [],
            formData: {
                selectMac: "",
                status: "",
                pubstatus: "2", //默认查询生产发布
                searchKey: "",
                dept: "",
                realPlatform: "",
            },
        });
        const formInput = reactive({
            title: "新增上岗申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            processIDReadonly: true,
            userSelType: 2, //1 开发人员 2 业务人员
            allTechs: [], //技术组担当
            allScenes: [], //场景组担当
            planPlatform: [], //部署平台
            digitalTypes: [], //员工类型
            hqOptions: [], //所有总部
            formData: {
                Id: "",
                AuditStatus: "0",
                reqNo: "", //需求编号
                ProcessName: "",
                ProcessID: "",
                processDesc: "",
                sceneBussValue: "",
                CreateMan: "",
                CreateManName: "",
                division: "",
                empType: "",
                introduction: "",
                techUID: "",
                techName: "",
                sceneUID: "",
                sceneName: "",
                UserName: "",
                UserNameEmail: "",
                UserId: "",
                UserIDName: [],
                realPlatform: "", //部署平台
                otherPlatform: "", //其他部署平台
                PubState: "",
                empVersion: "", //数字员工版本
                ManSingleTime: "",
                ManFrequency: "",
                DevelopTime: "",
                RobotSingleTime: "",
                RobotMonthRun: "",
                SingleSaveTime: "",
                otherAppID: "",
                verHistory: "",
                MachineName: "",
                fPathPackage: "",
                fPathPdd: "",
                fPathPhoto: "",
                isPro: false, //是否生产发布
                difyViewType: "",
                difyViewDivsion: "",
                empNo: "",
            },
            formRules: {
                reqNo: [{ required: false, message: "需求编号不能为空" }],
                ProcessName: [
                    { required: true, message: "数字员工名称不能为空" },
                ],
                processDesc: [
                    { required: false, message: "工作场景描述不能为空" },
                ],
                sceneBussValue: [
                    { required: false, message: "场景业务价值不能为空" },
                ],
                empType: [{ required: true, message: "数字员工类型不能为空" }],
                introduction: [
                    { required: true, message: "数字员工简介不能为空" },
                ],
                techUID: [{ required: true, message: "辅导老师不能为空" }],
                sceneUID: [{ required: false, message: "场景组担当不能为空" }],
                UserNameEmail: [
                    { required: true, message: "业务人员不能为空" },
                ],
                PubState: [{ required: true, message: "发布阶段不能为空" }],
                empVersion: [
                    { required: true, message: "数字员工版本不能为空" },
                ],
                realPlatform: [{ required: true, message: "部署平台不能为空" }],
                otherPlatform: [{ required: false, message: "不能为空" }],
                ManSingleTime: [
                    {
                        required: false,
                        message: "Before-人工每次耗时(分钟)不能为空",
                    },
                ],
                ManFrequency: [
                    { required: false, message: "Before-人工每月次数不能为空" },
                ],
                DevelopTime: [{ required: false, message: "开发时长不能为空" }],
                RobotSingleTime: [
                    {
                        required: false,
                        message: "After-每次耗时(分钟)不能为空",
                    },
                ],
                RobotMonthRun: [
                    { required: false, message: "After-每月次数不能为空" },
                ],
                otherAppID: [{ required: false, message: "外部AppID不能为空" }],
                verHistory: [
                    { required: false, message: "版本变更备注不能为空" },
                ],
                fPathPackage: [{ required: true, message: "程序包不能为空" }],
                fPathPdd: [{ required: true, message: "设计文档不能为空" }],
                fPathPhoto: [
                    { required: false, message: "数字员工照片不能为空" },
                ],
                difyViewType: [
                    { required: false, message: "Dify员工公开范围不能为空" },
                ],
                difyViewDivsion: [
                    { required: false, message: "公开总部不能为空" },
                ],
            },
        });
        const addNewPublishRef = ref(null);
        const activeKey = ref("1");
        return {
            formInput,
            tableData: null,
            tableDataHis: null,
            tablePager,
            toolbar,
            pageHeight,
            dtUser: null,
            iShowSelectUser: ref(false),
            onePackageFile: {}, //上传的附件
            isShowPackageLink: false,
            onePDDFile: {}, //上传的附件
            isShowPDDLink: false,
            onePhotoFile: {}, //上传的附件
            isShowPhotoLink: false,
            dtAudit: [],
            isShowAuditList: false,
            isShowEditRow: false, //管理员编辑列
            isShowRequireSel: false, //发布申请，选择需求
            dtReqs: [], //需求列表
            tableHeight: 0,
            submitting: false,
            activeKey,
            isViewFooter: true,
            otherPlatformLabel: "其他部署平台",
            isDifyDE: false,
            addNewPublishRef,
        };
    },
    methods: {
        formatTime({ cellValue }) {
            return XEUtils.toDateString(cellValue, "yyyy-MM-dd");
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.selectMac,
                    this.toolbar.formData.status,
                    this.toolbar.formData.pubstatus,
                    "",
                    this.toolbar.formData.realPlatform,
                ],
            };
            this.$api.newPublishManageAPI
                .getDigitalEmpList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        bindAllStatus() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["28"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.allStatus = [];
                    for (const item of res.data.Data) {
                        if (!["5", "6", "7"].includes(item.LookupValueCode)) {
                            continue;
                        }
                        this.toolbar.allStatus.push({
                            value: item.LookupValueCode,
                            label:
                                item.LookupValueName == "已审核"
                                    ? "已上岗"
                                    : item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showAuditList(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;
                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addAuditRecord(status, type) {
            let auditBuId = "";
            let auditOpinion = "";
            switch (type) {
                case "1":
                    auditBuId = this.formInput.formData.Id;
                    auditOpinion = "";
                    break;
                case "2":
                    auditBuId = this.formInputRetire.formData.Id;
                    auditOpinion = "数字员工退役发起";
                    break;
                case "3":
                    auditBuId = this.formInputAddMan.formData.Id;
                    auditOpinion = "添加业务使用人发起";
                    break;
            }
            //写审核日志
            const params = {
                auditBuId: auditBuId,
                auditMan: this.$store.state.userName,
                auditManUid: this.$store.state.userID,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: auditOpinion,
                auditNode: "审核发起",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindPC() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: ["0"], //RPA
            };
            this.$api.systemManageAPI
                .getMachineListByType(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.RobotName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
            this.toolbar.formData.selectMac = "";
            this.toolbar.formData.realPlatform = "";
        },
        //删除
        async removeRowEvent(row) {
            if (
                row.AuditStatus.includes("审核中") ||
                ["已审核", "已上岗", "退役中"].includes(row.AuditStatus)
            ) {
                await VXETable.modal.message({
                    content: "不能删除，请联系管理员",
                    status: "error",
                });
                return;
            }

            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.xTable1;
            if (type === "confirm") {
                this.$api.newPublishManageAPI
                    .delPublish(
                        Qs.stringify({ publishId: row.Id, editType: "1" })
                    )
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });

                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //管理员修改
        editAdminEvent(row) {
            this.$refs.addNewPublishRef.editRowEvent(row, 2);
        },
        //编辑数据
        editRowEvent(row) {
            this.$refs.addNewPublishRef.editRowEvent(row, 1);
        },
        onDifyViewTypeChange() {
            this.formInput.formRules.difyViewDivsion[0].required =
                this.formInput.formData.difyViewType === "2";
        },

        setupAIAssistant(row) {
            this.$refs.addAIAssistantRef.addAIAssistant(row);
        },
        downloadYaml(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 0,
                pageSize: 0,
                searchKey: [row.Id],
            };

            this.$api.newPublishManageAPI
                .getDifyYAML(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        let err_msg = "";
                        try {
                            err_msg = JSON.parse(res.data.Message);
                            err_msg = Object.entries(err_msg)
                                .map(([key, val]) => `${key}: ${val}`)
                                .join(", ");
                        } catch {
                            err_msg = res.data.Message;
                        }
                        VXETable.modal.message({
                            content: err_msg,
                            status: "error",
                        });
                        return;
                    }
                    console.log(res.data.Data);
                    navigator.clipboard
                        .writeText(res.data.Data)
                        .then(() => {
                            VXETable.modal.message({
                                content: "已复制到剪切板",
                                status: "success",
                            });
                        })
                        .catch((err) => {
                            console.error("复制失败: ", err);
                        });
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        closeWinEvent() {
            this.findData();
        },

        exportDataEvent() {
            const $table = this.$refs.xTable1;
            $table.exportData({ type: "csv" });
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        onSelectPubState() {
            //测试发布
            if (this.formInput.formData.PubState === "1") {
                this.formInput.formData.isPro = false;
                if (this.editType == "1") {
                    //新增时校验
                    this.formInput.formRules.fPathPackage[0].required = true;
                    this.formInput.formRules.fPathPdd[0].required = true;
                }
                this.formInput.formRules.fPathPhoto[0].required = false;
                this.formInput.formRules.ManSingleTime[0].required = false;
                this.formInput.formRules.ManFrequency[0].required = false;
                this.formInput.formRules.DevelopTime[0].required = false;
                this.formInput.formRules.RobotSingleTime[0].required = false;
                this.formInput.formRules.RobotMonthRun[0].required = false;

                this.formInput.formData.ManSingleTime = 0;
                this.formInput.formData.ManFrequency = 0;
                this.formInput.formData.DevelopTime = 0;
                this.formInput.formData.RobotSingleTime = 0;
                this.formInput.formData.RobotMonthRun = 0;
            } else {
                this.formInput.formData.isPro = true;

                if (this.editType == "1") {
                    this.formInput.formRules.fPathPhoto[0].required = true;
                    this.formInput.formRules.fPathPackage[0].required = true;
                    this.formInput.formRules.fPathPdd[0].required = true;
                }

                this.formInput.formRules.ManSingleTime[0].required = true;
                this.formInput.formRules.ManFrequency[0].required = true;
                this.formInput.formRules.DevelopTime[0].required = true;
                this.formInput.formRules.RobotSingleTime[0].required = true;
                this.formInput.formRules.RobotMonthRun[0].required = true;
            }
            //选其他部署平台，就要必填其他部署平台
            this.formInput.formRules.otherPlatform[0].required =
                this.formInput.formData.realPlatform === "PT006" ||
                this.formInput.formData.realPlatform === "PT003";
            //选Dify就填外部APPID
            this.formInput.formRules.otherAppID[0].required =
                this.formInput.formData.realPlatform === "PT003";
            this.otherPlatformLabel =
                this.formInput.formData.realPlatform === "PT003"
                    ? "Dify链接"
                    : "其他部署平台";
            this.isDifyDE = this.formInput.formData.realPlatform === "PT003";
            this.formInput.formRules.difyViewType[0].required =
                this.formInput.formData.realPlatform === "PT003";
            this.formInput.formRules.difyViewDivsion[0].required =
                this.formInput.formData.realPlatform === "PT003";
        },
        async insertPackageEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.formInput.formData.fPathPackage = file.name;
                this.onePackageFile = file;
            });
        },
        async insertPDDEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.formInput.formData.fPathPdd = file.name;
                this.onePDDFile = file;
            });
        },
        async insertPhotoEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.formInput.formData.fPathPhoto = file.name;
                this.onePhotoFile = file;
            });
        },

        downloadFile(type) {
            this.$api.fileManageAPI
                .downloadPublishFile(
                    Qs.stringify({
                        publishId: this.formInput.formData.Id,
                        type: type,
                    })
                )
                .then(async (res) => {
                    const contentType = res.headers["content-type"] || "";

                    // 后端返回错误JSON
                    if (contentType.includes("application/json")) {
                        const text = await res.data.text();

                        try {
                            const result = JSON.parse(text);

                            VXETable.modal.alert({
                                content: result.Message || "下载失败",
                                status: "error",
                            });
                        } catch (e) {
                            VXETable.modal.alert({
                                content: text,
                                status: "error",
                            });
                        }

                        return;
                    }

                    let fileName = "下载文件";

                    const disposition =
                        res.headers["content-disposition"] ||
                        res.headers["Content-Disposition"];

                    if (disposition) {
                        const utf8Match = disposition.match(
                            /filename\*=UTF-8''([^;]+)/i
                        );

                        const normalMatch =
                            disposition.match(/filename="?([^"]+)"?/i);

                        if (utf8Match && utf8Match[1]) {
                            fileName = decodeURIComponent(utf8Match[1]);
                        } else if (normalMatch && normalMatch[1]) {
                            fileName = decodeURIComponent(normalMatch[1]);
                        }
                    }

                    const blob = new Blob([res.data], {
                        type: contentType || "application/octet-stream",
                    });

                    if (blob.size === 0) {
                        VXETable.modal.alert({
                            content: "文件内容为空",
                            status: "error",
                        });
                        return;
                    }

                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement("a");
                    a.href = url;
                    a.download = fileName;
                    a.style.display = "none";

                    document.body.appendChild(a);

                    a.click();

                    document.body.removeChild(a);

                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.error(error);

                    VXETable.modal.alert({
                        content: "文件下载失败",
                        status: "error",
                    });
                });
        },
        checkHasFiles() {
            this.$api.newPublishManageAPI
                .checkPublishHasFiles(
                    Qs.stringify({
                        publishId: this.formInput.formData.Id,
                        type: "",
                    })
                )
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.alert({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    let fileStatus = res.data.Data.split(",");

                    this.isShowPackageLink = fileStatus[0] === "1";
                    this.isShowPDDLink = fileStatus[1] === "1";
                    this.isShowPhotoLink = fileStatus[2] === "1";
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //提交
        async submit() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                this.submitting = false;
                return;
            }
            const type = await VXETable.modal.confirm("您确定要提交该数据吗?");
            const $grid = this.$refs.xTable1;
            if (type === "confirm") {
                const data = this.getModel();

                this.submitting = true;
                this.$api.newPublishManageAPI
                    .submitPublish(data)
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitting = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.addAuditRecord("0", "1"); //写审核日志
                        this.formInput.isShow = false;
                        this.submitting = false;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitting = false;
                        console.log(error);
                    });
            }
        },
        //提交退役申请
        async submitRetire() {
            const $rForm = this.$refs.rFormRetire;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                this.submitting = false;
                return;
            }
            const type = await VXETable.modal.confirm("您确定要提交该数据吗?");

            if (type === "confirm") {
                const data = this.formInputRetire.formData;

                this.submitting = true;
                this.$api.newPublishManageAPI
                    .submitPublishRetire(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitting = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.addAuditRecord("0", "2"); //写审核日志
                        this.formInputRetire.isShow = false;
                        this.submitting = false;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitting = false;
                        console.log(error);
                    });
            }
        },
        //提交申请使用人
        async submitAddMan() {
            const $rForm = this.$refs.rFormAddMan;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                this.submitting = false;
                return;
            }
            const type = await VXETable.modal.confirm("您确定要提交该数据吗?");

            if (type === "confirm") {
                this.formInputAddMan.formData.UserName =
                    this.formInputAddMan.formData.UserId;
                const data = this.formInputAddMan.formData;

                this.submitting = true;
                this.$api.newPublishManageAPI
                    .submitPublishAddMan(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitting = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.addAuditRecord("0", "3"); //写审核日志
                        this.formInputAddMan.isShow = false;
                        this.submitting = false;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitting = false;
                        console.log(error);
                    });
            }
        },
        updateSingleSaveTime() {
            this.formInput.formData.SingleSaveTime =
                this.formInput.formData.ManSingleTime -
                this.formInput.formData.RobotSingleTime;
        },
        findAddManHis(pubId) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [pubId],
            };
            this.$api.newPublishManageAPI
                .getProcessAddManList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableDataHis = res.data.Data.dataTable;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addPackageQueue(publishid) {
            //插入包更新队列
            const params = {
                Id: "",
                Priority: 1,
                PubId: publishid,
                HandleType: 1, //0首次 1 更新包
                Status: 0, // 待处理
                StartTime: "",
                EndTime: "",
                Creator: this.$store.state.userID,
                CreationTime: "",
                ErrorMsg: "",
                ExtraMsg: "",
            };
            this.$api.newPublishManageAPI
                .addPackageQueue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindAllReqPlatform() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["27"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.formInput.allReqPlatform = [];
                    for (const item of res.data.Data) {
                        this.formInput.allReqPlatform.push({
                            value: item.LookupValueCode,
                            label: item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindTechMember() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getTechMemberList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.allTechs = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.allTechs.push({
                            value: item.uid,
                            label: item.userName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindSceneMember() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getSceneMemberList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.allScenes = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.allScenes.push({
                            value: item.uid,
                            label: item.userName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindPlatform() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getDeployPlatformList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.planPlatform = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.planPlatform.push({
                            value: item.code,
                            label: item.name,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindDigitalType() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getDigitalMemberTypeList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.digitalTypes = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.digitalTypes.push({
                            value: item.code,
                            label: item.name,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindHQ() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 50,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getHeadquarterList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        console.log(res.data.Message);
                        return;
                    }
                    // console.log(res.data.Data);
                    this.formInput.hqOptions = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.hqOptions.push({
                            value: item.hqCode,
                            label: item.hqName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.bindPC();
        this.bindHQ();
        this.bindAllStatus();
        this.bindTechMember();
        this.bindSceneMember();
        this.bindPlatform();
        this.bindDigitalType();
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    created() {
        this.isShowEditRow = this.$store.state.isAdmin === "1";
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
    computed: {
        getUserName() {
            return this.$store.state.userName;
        },
        getJobZb() {
            return this.$store.state.jobZb;
        },
        getJobName() {
            return this.$store.state.jobName;
        },
        getUserEmail() {
            return this.$store.state.email;
        },
        getUserUID() {
            return this.$store.state.userID;
        },
        getUserId() {
            return this.$store.state.Id;
        },
        getTechName() {
            const selected = this.formInput.allTechs.find(
                (t) => t.value === this.formInput.formData.techUID
            );
            return selected ? selected.label : "";
        },
        getSceneName() {
            const selected = this.formInput.allScenes.find(
                (t) => t.value === this.formInput.formData.sceneUID
            );
            return selected ? selected.label : "";
        },
    },
};
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
